/*----- Great Hall Gallery -----*/
import greatHall1 from "../assets/images/great-hall/greatHall1.jpg";
import greatHall2 from "../assets/images/great-hall/greatHall2.jpg";
import greatHall3 from "../assets/images/great-hall/greatHall3.jpg";
import greatHall4 from "../assets/images/great-hall/greatHall4.jpg";
import greatHall5 from "../assets/images/great-hall/greatHall5.jpg";
import greatHall6 from "../assets/images/great-hall/greatHall6.jpg";
import greatHall7 from "../assets/images/great-hall/greatHall7.jpg";
import greatHall8 from "../assets/images/great-hall/greatHall8.jpg";
import greatHall9 from "../assets/images/great-hall/greatHall9.jpg";
import greatHall10 from "../assets/images/great-hall/greatHall10.jpg";
import greatHall11 from "../assets/images/great-hall/greatHall11.jpg";
import greatHall12 from "../assets/images/great-hall/greatHall12.jpg";
import greatHall13 from "../assets/images/great-hall/greatHall13.jpg";
import greatHall14 from "../assets/images/great-hall/greatHall14.jpg";
import greatHall15 from "../assets/images/great-hall/greatHall15.jpg";
import greatHall16 from "../assets/images/great-hall/greatHall16.jpg";
import greatHall17 from "../assets/images/great-hall/greatHall17.jpg";
import greatHall18 from "../assets/images/great-hall/greatHall18.jpg";
import greatHall19 from "../assets/images/great-hall/greatHall19.jpg";
import greatHall20 from "../assets/images/great-hall/greatHall20.jpg";
import greatHall21 from "../assets/images/great-hall/greatHall21.jpg";
import greatHall22 from "../assets/images/great-hall/greatHall22.jpg";
import greatHall23 from "../assets/images/great-hall/greatHall23.jpg";
import greatHall24 from "../assets/images/great-hall/greatHall24.jpg";
import greatHall25 from "../assets/images/great-hall/greatHall25.jpg";
import greatHall26 from "../assets/images/great-hall/greatHall26.jpg";
import greatHall27 from "../assets/images/great-hall/greatHall27.jpg";
import greatHall28 from "../assets/images/great-hall/greatHall28.png";
import greatHall29 from "../assets/images/great-hall/greatHall29.jpg";
import greatHall30 from "../assets/images/great-hall/greatHall30.jpg";
import greatHall31 from "../assets/images/great-hall/greatHall31.jpg";
import greatHall32 from "../assets/images/great-hall/greatHall32.jpg";
import greatHall33 from "../assets/images/great-hall/greatHall33.jpg";
import greatHall34 from "../assets/images/great-hall/greatHall34.jpg";
import greatHall35 from "../assets/images/great-hall/greatHall35.jpg";
import greatHall36 from "../assets/images/great-hall/greatHall36.jpg";
import greatHall37 from "../assets/images/great-hall/greatHall37.jpg";
import greatHall38 from "../assets/images/great-hall/greatHall38.jpg";
import greatHall39 from "../assets/images/great-hall/greatHall39.jpg";
import greatHall40 from "../assets/images/great-hall/greatHall40.jpg";
import greatHall41 from "../assets/images/great-hall/greatHall41.jpg";
import greatHall42 from "../assets/images/great-hall/greatHall42.jpg";
import greatHall43 from "../assets/images/great-hall/greatHall43.jpg";
import greatHall44 from "../assets/images/great-hall/greatHall44.jpg";
import greatHall45 from "../assets/images/great-hall/greatHall45.jpg";
import greatHall46 from "../assets/images/great-hall/greatHall46.jpg";
import greatHall47 from "../assets/images/great-hall/greatHall47.jpg";
import greatHall48 from "../assets/images/great-hall/greatHall48.jpg";
import greatHall49 from "../assets/images/great-hall/greatHall49.jpg";
import greatHall50 from "../assets/images/great-hall/greatHall50.jpg";
import greatHall51 from "../assets/images/great-hall/greatHall51.jpg";

/*----- Crystal Hall Gallery -----*/
import crystalHall1 from "../assets/images/crystal-hall/crystalHall1.jpg";
import crystalHall2 from "../assets/images/crystal-hall/crystalHall2.jpg";
import crystalHall3 from "../assets/images/crystal-hall/crystalHall3.jpg";
import crystalHall4 from "../assets/images/crystal-hall/crystalHall4.jpg";
import crystalHall5 from "../assets/images/crystal-hall/crystalHall5.jpg";
import crystalHall6 from "../assets/images/crystal-hall/crystalHall6.jpg";
import crystalHall7 from "../assets/images/crystal-hall/crystalHall7.jpg";
import crystalHall8 from "../assets/images/crystal-hall/crystalHall8.jpg";
import crystalHall9 from "../assets/images/crystal-hall/crystalHall9.jpg";
import crystalHall10 from "../assets/images/crystal-hall/crystalHall10.jpg";
import crystalHall11 from "../assets/images/crystal-hall/crystalHall11.jpg";
import crystalHall12 from "../assets/images/crystal-hall/crystalHall12.jpg";
import crystalHall13 from "../assets/images/crystal-hall/crystalHall13.jpg";
import crystalHall14 from "../assets/images/crystal-hall/crystalHall14.jpg";
import crystalHall15 from "../assets/images/crystal-hall/crystalHall15.jpg";
import crystalHall16 from "../assets/images/crystal-hall/crystalHall16.jpg";
import crystalHall17 from "../assets/images/crystal-hall/crystalHall17.jpg";
import crystalHall18 from "../assets/images/crystal-hall/crystalHall18.jpg";
import crystalHall19 from "../assets/images/crystal-hall/crystalHall19.jpg";
import crystalHall20 from "../assets/images/crystal-hall/crystalHall20.jpg";

/*----- Small Hall Gallery -----*/
import smallHall1 from "../assets/images/small-hall/smallHall1.jpg";
import smallHall2 from "../assets/images/small-hall/smallHall2.jpg";
import smallHall3 from "../assets/images/small-hall/smallHall3.jpg";
import smallHall4 from "../assets/images/small-hall/smallHall4.jpg";
import smallHall5 from "../assets/images/small-hall/smallHall5.jpg";
import smallHall6 from "../assets/images/small-hall/smallHall6.jpg";
import smallHall7 from "../assets/images/small-hall/smallHall7.jpg";
import smallHall8 from "../assets/images/small-hall/smallHall8.jpg";
import smallHall9 from "../assets/images/small-hall/smallHall9.jpg";
import smallHall10 from "../assets/images/small-hall/smallHall10.jpg";
import smallHall11 from "../assets/images/small-hall/smallHall11.jpg";
import smallHall12 from "../assets/images/small-hall/smallHall12.jpg";
import smallHall13 from "../assets/images/small-hall/smallHall13.jpg";
import smallHall14 from "../assets/images/small-hall/smallHall14.jpg";
import smallHall15 from "../assets/images/small-hall/smallHall15.jpg";
import smallHall16 from "../assets/images/small-hall/smallHall16.jpg";
import smallHall17 from "../assets/images/small-hall/smallHall17.jpg";
import smallHall18 from "../assets/images/small-hall/smallHall18.jpg";
import smallHall19 from "../assets/images/small-hall/smallHall19.jpg";
import smallHall20 from "../assets/images/small-hall/smallHall20.jpg";
import smallHall21 from "../assets/images/small-hall/smallHall21.jpg";

/*----- Playroom Gallery -----*/
import playroom1 from "../assets/images/playroom/playroom1.jpg";
import playroom2 from "../assets/images/playroom/playroom2.jpg";
import playroom3 from "../assets/images/playroom/playroom3.jpg";
import playroom4 from "../assets/images/playroom/playroom4.jpg";
import playroom5 from "../assets/images/playroom/playroom5.jpg";
import playroom6 from "../assets/images/playroom/playroom6.jpg";
import playroom7 from "../assets/images/playroom/playroom7.jpg";
import playroom8 from "../assets/images/playroom/playroom8.jpg";
import playroom9 from "../assets/images/playroom/playroom9.jpg";
import playroom10 from "../assets/images/playroom/playroom10.jpg";
import playroom11 from "../assets/images/playroom/playroom11.jpg";
import playroom12 from "../assets/images/playroom/playroom12.jpg";
import playroom13 from "../assets/images/playroom/playroom13.jpg";
import playroom14 from "../assets/images/playroom/playroom14.jpg";
import playroom15 from "../assets/images/playroom/playroom15.jpg";
import playroom16 from "../assets/images/playroom/playroom16.jpg";
import playroom17 from "../assets/images/playroom/playroom17.jpg";
import playroom18 from "../assets/images/playroom/playroom18.jpg";
import playroom19 from "../assets/images/playroom/playroom19.jpg";
import playroom20 from "../assets/images/playroom/playroom20.jpg";
import playroom21 from "../assets/images/playroom/playroom21.jpg";
import playroom22 from "../assets/images/playroom/playroom22.jpg";
import playroom23 from "../assets/images/playroom/playroom23.jpg";
import playroom24 from "../assets/images/playroom/playroom24.jpg";
import playroom25 from "../assets/images/playroom/playroom25.jpg";
import playroom26 from "../assets/images/playroom/playroom26.jpg";
import playroom27 from "../assets/images/playroom/playroom27.jpg";
import playroom28 from "../assets/images/playroom/playroom28.jpg";

/*----- Catering Gallery -----*/
import catering1 from "../assets/images/catering/catering1.jpg";
import catering2 from "../assets/images/catering/catering2.jpg";
import catering3 from "../assets/images/catering/catering3.jpg";
import catering4 from "../assets/images/catering/catering4.jpg";
import catering5 from "../assets/images/catering/catering5.jpg";
import catering6 from "../assets/images/catering/catering6.jpg";
import catering7 from "../assets/images/catering/catering7.jpg";
import catering8 from "../assets/images/catering/catering8.jpg";
import catering9 from "../assets/images/catering/catering9.jpg";
import catering10 from "../assets/images/catering/catering10.jpg";
import catering11 from "../assets/images/catering/catering11.jpg";
import catering12 from "../assets/images/catering/catering12.jpg";
import catering13 from "../assets/images/catering/catering13.jpg";
import catering14 from "../assets/images/catering/catering14.jpg";
import catering15 from "../assets/images/catering/catering15.jpg";
import catering16 from "../assets/images/catering/catering16.jpg";
import catering17 from "../assets/images/catering/catering17.jpg";
import catering18 from "../assets/images/catering/catering18.jpg";
import catering19 from "../assets/images/catering/catering19.jpg";
import catering20 from "../assets/images/catering/catering20.jpg";

export const GalleryData = [
  {
    id: 1,
    category: "greathall",
    image: greatHall1,
  },
  {
    id: 2,
    category: "greathall",
    image: greatHall2,
  },
  {
    id: 3,
    category: "greathall",
    image: greatHall3,
  },
  {
    id: 4,
    category: "greathall",
    image: greatHall4,
  },
  {
    id: 5,
    category: "greathall",
    image: greatHall5,
  },
  {
    id: 6,
    category: "greathall",
    image: greatHall6,
  },
  {
    id: 7,
    category: "greathall",
    image: greatHall7,
  },
  {
    id: 8,
    category: "greathall",
    image: greatHall8,
  },
  {
    id: 9,
    category: "greathall",
    image: greatHall9,
  },
  {
    id: 10,
    category: "greathall",
    image: greatHall10,
  },
  {
    id: 11,
    category: "greathall",
    image: greatHall11,
  },
  {
    id: 12,
    category: "greathall",
    image: greatHall12,
  },
  {
    id: 13,
    category: "greathall",
    image: greatHall13,
  },
  {
    id: 14,
    category: "greathall",
    image: greatHall14,
  },
  {
    id: 15,
    category: "greathall",
    image: greatHall15,
  },
  {
    id: 16,
    category: "greathall",
    image: greatHall16,
  },
  {
    id: 17,
    category: "greathall",
    image: greatHall17,
  },
  {
    id: 18,
    category: "greathall",
    image: greatHall18,
  },
  {
    id: 19,
    category: "greathall",
    image: greatHall19,
  },
  {
    id: 20,
    category: "greathall",
    image: greatHall20,
  },
  {
    id: 21,
    category: "greathall",
    image: greatHall21,
  },
  {
    id: 22,
    category: "greathall",
    image: greatHall22,
  },
  {
    id: 23,
    category: "greathall",
    image: greatHall23,
  },
  {
    id: 24,
    category: "greathall",
    image: greatHall24,
  },
  {
    id: 25,
    category: "greathall",
    image: greatHall25,
  },
  {
    id: 26,
    category: "greathall",
    image: greatHall26,
  },
  {
    id: 27,
    category: "greathall",
    image: greatHall27,
  },
  {
    id: 28,
    category: "greathall",
    image: greatHall28,
  },
  {
    id: 29,
    category: "greathall",
    image: greatHall29,
  },
  {
    id: 30,
    category: "greathall",
    image: greatHall30,
  },
  {
    id: 31,
    category: "greathall",
    image: greatHall31,
  },
  {
    id: 32,
    category: "greathall",
    image: greatHall32,
  },
  {
    id: 33,
    category: "greathall",
    image: greatHall33,
  },
  {
    id: 34,
    category: "greathall",
    image: greatHall34,
  },
  {
    id: 35,
    category: "greathall",
    image: greatHall35,
  },
  {
    id: 36,
    category: "greathall",
    image: greatHall36,
  },
  {
    id: 37,
    category: "greathall",
    image: greatHall37,
  },
  {
    id: 38,
    category: "greathall",
    image: greatHall38,
  },
  {
    id: 39,
    category: "greathall",
    image: greatHall39,
  },
  {
    id: 40,
    category: "greathall",
    image: greatHall40,
  },
  {
    id: 41,
    category: "greathall",
    image: greatHall41,
  },
  {
    id: 42,
    category: "greathall",
    image: greatHall42,
  },
  {
    id: 43,
    category: "greathall",
    image: greatHall43,
  },
  {
    id: 44,
    category: "greathall",
    image: greatHall44,
  },
  {
    id: 45,
    category: "greathall",
    image: greatHall45,
  },
  {
    id: 46,
    category: "greathall",
    image: greatHall46,
  },
  {
    id: 47,
    category: "greathall",
    image: greatHall47,
  },
  {
    id: 48,
    category: "greathall",
    image: greatHall48,
  },
  {
    id: 49,
    category: "greathall",
    image: greatHall49,
  },
  {
    id: 50,
    category: "greathall",
    image: greatHall50,
  },
  {
    id: 51,
    category: "greathall",
    image: greatHall51,
  },
  {
    id: 52,
    category: "crystalhall",
    image: crystalHall1,
  },
  {
    id: 53,
    category: "crystalhall",
    image: crystalHall2,
  },
  {
    id: 54,
    category: "crystalhall",
    image: crystalHall3,
  },
  {
    id: 55,
    category: "crystalhall",
    image: crystalHall4,
  },
  {
    id: 56,
    category: "crystalhall",
    image: crystalHall5,
  },
  {
    id: 57,
    category: "crystalhall",
    image: crystalHall6,
  },
  {
    id: 58,
    category: "crystalhall",
    image: crystalHall7,
  },
  {
    id: 59,
    category: "crystalhall",
    image: crystalHall8,
  },
  {
    id: 60,
    category: "crystalhall",
    image: crystalHall9,
  },
  {
    id: 61,
    category: "crystalhall",
    image: crystalHall10,
  },
  {
    id: 62,
    category: "crystalhall",
    image: crystalHall11,
  },
  {
    id: 63,
    category: "crystalhall",
    image: crystalHall12,
  },
  {
    id: 64,
    category: "crystalhall",
    image: crystalHall13,
  },
  {
    id: 65,
    category: "crystalhall",
    image: crystalHall14,
  },
  {
    id: 66,
    category: "crystalhall",
    image: crystalHall15,
  },
  {
    id: 67,
    category: "crystalhall",
    image: crystalHall16,
  },
  {
    id: 68,
    category: "crystalhall",
    image: crystalHall17,
  },
  {
    id: 69,
    category: "crystalhall",
    image: crystalHall18,
  },
  {
    id: 70,
    category: "crystalhall",
    image: crystalHall19,
  },
  {
    id: 71,
    category: "crystalhall",
    image: crystalHall20,
  },
  {
    id: 72,
    category: "smallhall",
    image: smallHall1,
  },
  {
    id: 73,
    category: "smallhall",
    image: smallHall2,
  },
  {
    id: 74,
    category: "smallhall",
    image: smallHall3,
  },
  {
    id: 75,
    category: "smallhall",
    image: smallHall4,
  },
  {
    id: 76,
    category: "smallhall",
    image: smallHall5,
  },
  {
    id: 77,
    category: "smallhall",
    image: smallHall6,
  },
  {
    id: 78,
    category: "smallhall",
    image: smallHall7,
  },
  {
    id: 79,
    category: "smallhall",
    image: smallHall8,
  },
  {
    id: 80,
    category: "smallhall",
    image: smallHall9,
  },
  {
    id: 81,
    category: "smallhall",
    image: smallHall10,
  },
  {
    id: 82,
    category: "smallhall",
    image: smallHall11,
  },
  {
    id: 83,
    category: "smallhall",
    image: smallHall12,
  },
  {
    id: 84,
    category: "smallhall",
    image: smallHall13,
  },
  {
    id: 85,
    category: "smallhall",
    image: smallHall14,
  },
  {
    id: 86,
    category: "smallhall",
    image: smallHall15,
  },
  {
    id: 87,
    category: "smallhall",
    image: smallHall16,
  },
  {
    id: 88,
    category: "smallhall",
    image: smallHall17,
  },
  {
    id: 89,
    category: "smallhall",
    image: smallHall18,
  },
  {
    id: 90,
    category: "smallhall",
    image: smallHall19,
  },
  {
    id: 91,
    category: "smallhall",
    image: smallHall20,
  },
  {
    id: 92,
    category: "smallhall",
    image: smallHall21,
  },
  {
    id: 93,
    category: "playroom",
    image: playroom1,
  },
  {
    id: 94,
    category: "playroom",
    image: playroom2,
  },
  {
    id: 95,
    category: "playroom",
    image: playroom3,
  },
  {
    id: 96,
    category: "playroom",
    image: playroom4,
  },
  {
    id: 97,
    category: "playroom",
    image: playroom5,
  },
  {
    id: 98,
    category: "playroom",
    image: playroom6,
  },
  {
    id: 99,
    category: "playroom",
    image: playroom7,
  },
  {
    id: 100,
    category: "playroom",
    image: playroom8,
  },
  {
    id: 101,
    category: "playroom",
    image: playroom9,
  },
  {
    id: 102,
    category: "playroom",
    image: playroom10,
  },
  {
    id: 103,
    category: "playroom",
    image: playroom11,
  },
  {
    id: 104,
    category: "playroom",
    image: playroom12,
  },
  {
    id: 105,
    category: "playroom",
    image: playroom13,
  },
  {
    id: 106,
    category: "playroom",
    image: playroom14,
  },
  {
    id: 107,
    category: "playroom",
    image: playroom15,
  },
  {
    id: 108,
    category: "playroom",
    image: playroom16,
  },
  {
    id: 109,
    category: "playroom",
    image: playroom17,
  },
  {
    id: 110,
    category: "playroom",
    image: playroom18,
  },
  {
    id: 111,
    category: "playroom",
    image: playroom19,
  },
  {
    id: 112,
    category: "playroom",
    image: playroom20,
  },
  {
    id: 113,
    category: "playroom",
    image: playroom21,
  },
  {
    id: 114,
    category: "playroom",
    image: playroom22,
  },
  {
    id: 115,
    category: "playroom",
    image: playroom23,
  },
  {
    id: 116,
    category: "playroom",
    image: playroom24,
  },
  {
    id: 117,
    category: "playroom",
    image: playroom25,
  },
  {
    id: 118,
    category: "playroom",
    image: playroom26,
  },
  {
    id: 119,
    category: "playroom",
    image: playroom27,
  },
  {
    id: 120,
    category: "playroom",
    image: playroom28,
  },
  {
    id: 121,
    category: "catering",
    image: catering1,
  },
  {
    id: 122,
    category: "catering",
    image: catering2,
  },
  {
    id: 123,
    category: "catering",
    image: catering3,
  },
  {
    id: 124,
    category: "catering",
    image: catering4,
  },
  {
    id: 125,
    category: "catering",
    image: catering5,
  },
  {
    id: 126,
    category: "catering",
    image: catering6,
  },
  {
    id: 127,
    category: "catering",
    image: catering7,
  },
  {
    id: 128,
    category: "catering",
    image: catering8,
  },
  {
    id: 129,
    category: "catering",
    image: catering9,
  },
  {
    id: 130,
    category: "catering",
    image: catering10,
  },
  {
    id: 131,
    category: "catering",
    image: catering11,
  },
  {
    id: 132,
    category: "catering",
    image: catering12,
  },
  {
    id: 133,
    category: "catering",
    image: catering13,
  },
  {
    id: 134,
    category: "catering",
    image: catering14,
  },
  {
    id: 135,
    category: "catering",
    image: catering15,
  },
  {
    id: 136,
    category: "catering",
    image: catering16,
  },
  {
    id: 137,
    category: "catering",
    image: catering17,
  },
  {
    id: 138,
    category: "catering",
    image: catering18,
  },
  {
    id: 139,
    category: "catering",
    image: catering19,
  },
  {
    id: 140,
    category: "catering",
    image: catering20,
  },
];
